.page {
	padding: 0 32px;
	display: flex;
	flex-direction: column;
	gap: 32px;
}

.pageHeader {
	top: 0;
	position: sticky;
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 16px 32px;
	background: white;
}

.pageTitle {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.pageTitle strong {
	font-weight: 700;
	color: var(--primary-color);
}

.titleLinks {
	padding: 8px;
	display: flex;
	gap: 8px;
	font-size: 16px;
}

.layout {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 16px;
}

.infoBox {
	border: 1px solid #eee;
	box-shadow: var(--basic-shadow);
	border-radius: 12px;
	padding: 16px;
	display: flex;
	flex-direction: column;
	align-items: start;
	gap: 16px;
}

.infoBox strong {
	color: var(--primary-color);
}

.infoBox p {
	max-width: 80ch;
}
